import React from 'react';

import NumberFormatInput from './NumberFormatInput';

import './form.scss';

const PhoneInput = ({ ref, ...props }) => {
    return <NumberFormatInput ref={ref} type="tel" format="(###) ###-####" {...props} />;
};

export default PhoneInput;
